import { Helmet } from "react-helmet"

function Saradnja() {
    return (
        <div className="flex-container full-width flex-grow-1">
            <Helmet>
                <title>Historiografija.ba | Saradnja</title>
                <meta
                    name="description"
                    content="Informacije o saradnji i objavljivanju članaka na portalu historiografija.ba"
                    data-react-helmet="true" 
                />
            </Helmet>
            <div className="full-width padding-2p static-page-container">
                <h1 className="font-weight-500 text-center">Saradnja</h1>
                <p>
                    Ukoliko imate informacije o novim knjigama, časopisima, naučnim skupovima, želite objaviti članak, recenziju ili polemički tekst, pošaljite nam vijest ili rad sa fotografijom na  
                     <a href="mailto:urednik@historiografija.ba">urednik@historiografija.ba</a>.
                    <br />
                    Recenzije ne mogu sadržavati više od 7 500 karaktera, a radovi ne smiju prelaziti 30 000 karaktera.
                    <br />
                    Svi tekstovi će biti recenzirani.
                </p>                
            </div>
        </div>
    )
}

export default Saradnja